import CoreServicesListingTabs from './CoreServicesListingTabs';

export { type CoreServicesListingTabsProps } from './CoreServicesListingTabs';
export default CoreServicesListingTabs;
